import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/eslcloud/apple-touch-icon.png?url";
import icon from "@/styles/eslcloud/favicon.ico?url";
import favicon from "@/styles/eslcloud/favicon.svg?url";
import isoImage27001 from "@/styles/eslcloud/iso-27001.svg?url";
import isoImage9001 from "@/styles/eslcloud/iso-9001.svg?url";
import loginBg from "@/styles/eslcloud/login-bg.jpg?url";
import logoDark from "@/styles/eslcloud/logo-dark.svg?url";
import loginLogo from "@/styles/eslcloud/logo.svg";
import logo from "@/styles/eslcloud/logo.svg?url";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#0066FF",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "header-logo-width": "146px",
        "header-logo-height": "22px",

        //#region Login
        "login-body-bg-color": "var(--color-primary)",
        "login-body-bg-image": `url("${loginBg}")`,
        "login-body-bg-size": "cover",
        "login-body-text-color": "var(--color-text)",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-display": "flex",
        "login-intro-bg-image": "",
        "login-intro-bg-size": "cover",
        "login-intro-bg-position": "50% 0",
        "login-intro-text-align": "left",
        "login-intro-flex-direction": "column",
        "login-intro-justify-content": "flex-end",
        "login-intro-align-items": "flex-start",
        "login-intro-padding": "60px",
        "login-title-font-size": "28px",
        "login-title-text-color": "",
        "login-title-font-weight": 600,
        "login-title-line-height": 1,
        "login-title-max-width": "400px",
        "login-title-padding": "0 0 16px 0",
        "login-subtitle-font-size": "16px",
        "login-subtitle-max-width": "400px",

        "login-form-title-font-size": "30px",
        "login-form-bg-color": "var(--color-white)",
        "login-form-text-color": "var(--color-text)",
        "login-form-border-left": "#efefef solid 1px",
        "login-form-input-border-color": "#efefef",
        "login-form-button-border-radius": "var(--input-border-radius)",
        "login-form-or-text-color": "#efefef",
        "login-form-or-border-color": "#efefef",
        "login-form-google-bg-color": "#007bf5",
        "login-form-more-text-color": "var(--color-primary)",
        "login-form-more-bg-color": "var(--color-white)",
        "login-form-more-border-color": "var(--color-primary)",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "200px",
        },
    },
    isoCertificates: [
        {
            image: isoImage9001,
            url: "",
        },
        {
            image: isoImage27001,
            url: "",
        },
    ],
};
